import * as angular from "angular";
import * as _ from "lodash"

angular
  .module('bringoz.admin.planning')
  .filter('jobWeight', jobWeight);

/* @ngInject */
function jobWeight(splitService, $filter) {
  return function jobWeightFilter(job, enableUnitDisplay, defaultValue) {

    const siteUnit = splitService.getWeightUnit();
    let weight = 0;

    if (_.get(job, 'packages.length')) {
      weight = _.reduce(job.packages, function (sum, p) {
        return sum + _.get(p, 'weight', 0);
      }, 0);
    }

    if (!weight) {
      return defaultValue || '--'
    }
    const weightUnit = $filter('translate')(siteUnit);
    return (weight).toFixed(Number.isInteger(weight) ? 0 : 2) + (enableUnitDisplay ? (' ' + weightUnit) : '');
  }
}
